import { getContract } from '../utils/near-utils';
import getConfig from '../config';

const { occContractMethods } = getConfig();

export const getOccTotalRewardsForProject = async (account, projectId) => {
  const contract = getContract(account, occContractMethods, 1);

  try {
    const occTotalForProject = await contract.mt_supply({
      token_id: `ft:${projectId}`,
    });
    return occTotalForProject;
  } catch (error) {
    console.log('Error in getOccTotalRewardsForProject ', error);
    throw error;
  }
};

export const getOccRewardsByStages = async (account, projectId) => {
  const contract = getContract(account, occContractMethods, 1);

  try {
    const occByStagesData = await contract.get_token_history({
      token_id: `ft:${projectId}`,
      from_stage_id: '0',
      to_stage_id: '1000',
    });

    return occByStagesData;
  } catch (error) {
    console.log('Error in getOccRewardsByStages ', error);
    throw error;
  }
};
